(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('replaceTemplate', filterFunc);

    function filterFunc(lodash) {
        return function(value, template) {
            //console.log('%csodName', 'color: #8e44ad', data);
            if (typeof value === 'string') {
                const stringReplacerRegex = /<value>/g; // can get this from the config in the future.
                return template.replace(stringReplacerRegex, value);
            }
            if (typeof value === 'object') {
                const objectReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
                return template.replace(objectReplacerRegex, function(match, submatch) {
                    return lodash.get(value, submatch, '');
                });
            }
        };
    }
})();